<template>
  <div>
    <v-row>
      <v-col :cols="5" :md="disabledAdd ? 10 : 8">
        <v-text-field
          class="mr-2"
          :disabled="disabled"
          :label="label"
          filled
          append-icon="mdi-magnify"
          v-model="searchValue"
          @keyup.enter="onSearch"
          @click:append="onSearch"
        />
      </v-col>
      <v-col cols="3" md="2" v-if="!disabledAdd">
        <v-btn
          depressed
          color="primary"
          block
          x-large
          @click="$router.push(locationForm)"
          >Add</v-btn
        >
      </v-col>
      <v-col cols="3" md="2">
        <v-btn depressed color="primary" block x-large @click="onSearch"
          >search</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
    },
    locationForm: {
      type: String,
    },
    label: {
      type: String,
      default: "Search",
    },
    disabledAdd: {
      type: Boolean,
      default: false,
    },
  }, // props

  data: () => ({
    searchValue: "",
  }), // data

  methods: {
    onSearch() {
      this.$emit("input", this.searchValue);
    },
  }, // methods
};
</script>

<style>
</style>
